// Holds the signed session token and attaches it to every API request, so the
// individual components keep calling fetch('/api/...') as before.

const KEY = 'okiru_session';
export const SIGNED_OUT_EVENT = 'okiru:signed-out';

export function getSessionToken() {
  try { return localStorage.getItem(KEY) || ''; } catch { return ''; }
}

export function setSessionToken(token) {
  try {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  } catch { /* private mode: the session lasts until reload */ }
}

const AUTH_URL = /^\/api\/auth\/(login|otp\/verify|sso-session)(\?|$)/;

export function installAuthFetch() {
  if (typeof window === 'undefined' || window.__okiruFetchInstalled) return;
  window.__okiruFetchInstalled = true;
  const original = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!url.startsWith('/api/')) return original(input, init);

    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    const token = getSessionToken();
    if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    const response = await original(input, { ...init, headers });

    if (AUTH_URL.test(url) && response.ok) {
      const body = await response.clone().json().catch(() => null);
      if (body && body.token) setSessionToken(body.token);
    } else if (!url.startsWith('/api/auth/') && (response.status === 401 || response.status === 403)) {
      const body = await response.clone().json().catch(() => null);
      if (body && (body.code === 'AUTH_REQUIRED' || body.code === 'ACCESS_EXPIRED' || body.code === 'ACCOUNT_SUSPENDED')) {
        setSessionToken('');
        window.dispatchEvent(new CustomEvent(SIGNED_OUT_EVENT, { detail: { code: body.code, message: body.error } }));
      }
    }
    return response;
  };
}
